import { TrafficSource } from './traffic-sources';

type UserArgs = {
    deviceType: 'desktop' | 'mobile';
    trafficSource: string;
    clickinId: string;
    timezone: string;
    age: string;
    gender: string;
    token: string;
};

export class User {
    private static instance: User;
    private readonly _deviceType: 'desktop' | 'mobile';
    private readonly _trafficSource: string;
    readonly clickinId: string = '';
    readonly timezone: string = '';
    readonly age: string = '';
    readonly gender: string = '';
    readonly token: string = '';

    constructor(args: UserArgs) {
        const {
            deviceType,
            trafficSource,
            clickinId,
            timezone,
            age,
            gender,
            token,
        } = args;

        this._deviceType = deviceType;
        this._trafficSource = trafficSource;
        this.clickinId = clickinId;
        this.timezone = timezone;
        this.age = age;
        this.gender = gender;
        this.token = token;
    }

    public get deviceType(): string {
        switch (this._deviceType) {
            case 'desktop':
                return 'c';
            default:
                return 'm';
        }
    }

    public get trafficSource(): string {
        if (!this._trafficSource) {
            return TrafficSource.DEFAULT;
        }

        switch (this._trafficSource) {
            case TrafficSource.EXOCLICK:
                return 'eck';

            case TrafficSource.PROPELLER:
                return 'pls';

            default:
                return this._trafficSource;
        }
    }

    private static makeUserFromWindow(): User {
        return new User({
            deviceType: window.__device_type__,
            trafficSource: window.__traffic_source__,
            clickinId: window.__clId__,
            timezone: window.__user__.userTimezone.toString(),
            age: window.__user__.age,
            gender: window.__user__.gender,
            token: window.__token__,
        });
    }

    public static getInstance(): User {
        if (!User.instance) {
            User.instance = User.makeUserFromWindow();
        }

        return User.instance;
    }
}
